import tree from '@/components/tree.vue'
import { zzsh } from '@/axios'
import Page from '@/components/page.vue'
import DelData from '@/components/delToast.vue'
import Grade from '../components/grade.vue'
import { Message } from 'element-ui'
import { bsid } from '@/common/common.js'
import myTables from '@/components/tables/tables.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				year:new Date().getFullYear(),
				level:"",
				name:""
			},
			// 党委提交文件
			dwFlies:{
				dwid:this.$store.state.user.userinfo.dwid,
				files:[]
			},
			gradeWin:false,
			tableData:[],
			totalPage:0,
			tableHeader: [     // 表头
				{prop: 'u_name', label: '党员'},
				// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
				{prop: 'year', label: '年份',width:"110",formatData: function (val) {
						return that.getdata.year
					}
				},
				{prop: 'level', label: '等级',width:"160", formatData: function (val) {
					console.log(val)
					if(val == 4){return "优秀"}
					else if(val == 3){return '合格'}
					else if(val == 2){return '基本合格'}
					else if(val == 1){return "不合格"}
					else{return '暂无评级'}
				}},
				// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '190',
					oper: [
						{name: '支部评级', style: {color:'#bb0000'}, clickFun: this.openWin},
						{name: '查看详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
						{name: '一键清空', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
		}
	},
	components:{tree,Page,DelData,Grade,myTables},
	mounted() {
		that.dataList();
		that.dwFiles();
	},
	created() {
		that = this;
	},
	methods:{
		closeGradeWin(){
			// 关闭弹窗
			this.gradeWin = false
		},
		// 数据
		dataList(){
			that.tableData = [];
			zzsh.appraiseList(that.getdata).then(res => {
				if(res.data.pagedata.length > 0){
					that.tableData = res.data.pagedata;
				}
				that.totalPage = res.data.count;
			})
		},
		// 详情
		showDetail(data){
			that.$router.push({
				path:"/mzpyjl_detail",
				query:{
					uid:data.id,
					year:that.getdata.year
				}
			})
		},
		// 上传限制
		limitFiles(file){
			var isJPG = file.type === 'application/pdf' 
				|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
				|| file.type === 'application/msword';
			var isLt2M = file.size / 1024 / 1024 < 20;
			if (!isJPG) {
				Message.error('仅支持pdf、doc、docx文件');
				return false;
			}
			if (!isLt2M) {
				Message.error('上传文件大小不能超过 20MB!');
				return false;
			}
			if(that.dwFlies.files.length>=4){
				Message.error("最多可传4个文件")
				return false;
			}
		},
		openWin(data){
			that.$refs.grade.openWin(true,data)
		},
		// 部分禁用删除
		selectEnable(row, rowIndex) {
			if (row.pub_flag == that.$store.state.user.userinfo.flag&&row.pub_id == that.$store.state.user.userinfo.id) {
			  return true
			}
		 },
		// 删除文件
		delDwFiles(id){
			zzsh.delAppraiseFiles({
				dwid:that.dwFlies.dwid,
				id:id
			}).then(res => {
				if(res.code == 200){
					that.dwFiles();
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 上传进度
		uploadProcess(event, file, fileList){
			const loading = this.$loading({
				lock: true,
				text: '上传中请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			});
			if(Math.floor(event.percent) == 100){
				loading.close();
			}
		},
		// 上传成功
		success1(res, file) {
			if(res.code == 200){
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					url:res.data.src
				}
				that.dwFlies.files = [];
				that.dwFlies.files.push(data);
				that.subDwFiles();
			}else{
				Message.error("上传失败")
			}
		},
		// 提交党委文件
		subDwFiles(){
			zzsh.addAppraiseFiles(that.dwFlies).then(res => {
				if(res.code == 200){
					that.dwFiles();
					that.dwFlies.files = [];
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 党委文件列表
		dwFiles(){
			that.dwFlies.files = [];
			zzsh.appraiseFilesList({
				dwid:that.dwFlies.dwid
			}).then(res => {
				if(res.code == 200){
					that.dwFlies.files = res.data;
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 下载党委文件
		zbDownloadFile(url){
			if(url){
				location.href = url;
			}else{
				Message({
					type:"error",
					message:"下载失败"
				})
			}
		},
		// 删除
		del(data){
			that.$refs.delDatas.showToast(res => {
				if(res){
					zzsh.clearAppraise({
						uid:data.id,
						year:data.year
					}).then(res => {
						if(res.code == 200){
							Message.success('成功!')
						}else{
							Message.error(res.msg)
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}
			})
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.user_id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.page = 1;
			that.dataList();
		},
		// 分页筛选
		changedata(curret){
			that.getdata.page = curret;
			that.dataList();
		},
	}
}